/** Açık: beyazda 3,96:1 · zeminde 3,67:1; kırmızı dolguda beyaz 6,57:1. */
export const controlLight = {
    borderControl: '#857F77',
    textOnDanger: '#FFFFFF',
};
/** Karanlık: yüzeyde 3,65:1 · zeminde 4,05:1; açık kırmızı dolguda koyu metin 8,15:1. */
export const controlDark = {
    borderControl: '#6B7A87',
    textOnDanger: '#1A1008',
};
/** Karanlık temada açık petrol mavisi dolgu üstü metin (`on-pri`, mobil adım düğmesi). */
export const onPrimaryDark = '#0B1A24';
//# sourceMappingURL=control-tokens.js.map